import React from 'react';
import {Navigate, Route, Routes} from "react-router-dom";
import Layout from "pages/layout";
import Unauthorized from "pages/unAuthorized";
import RequireAuth from "components/requireAuth";
import Dashboard from "pages/dashboard";
import Profil from "pages/profil/profil";
import MyAccountContent
    from "pages/profil/content/myAccount.content";
import LegalInformationContent
    from "pages/profil/content/legalInformation.content";
import ModesOfPaymentContent
    from "pages/profil/content/modesOfPayment.content";
import BonusesCompensationContent
    from "pages/profil/content/bonusesCompensation.content";
import PaymentsTermsContent
    from "pages/profil/content/paymentsTerms.content";
import TeamContent from "pages/profil/content/team.content";
import PermissionsContent from "pages/profil/content/permissions.content";
import PerimetersContent from "pages/profil/content/perimeters.content";
import Mission from "pages/missions/mission";
import EndContent from "pages/missions/content/end.content";
import InProgressContent
    from "pages/missions/content/inProgress.content";
import ComingSoonContent
    from "pages/missions/content/comingSoon.content";
import Contract from "pages/contract/contract";
import SignedContent
    from "pages/files/contract/content/signed.content";
import ToBeSignedContent
    from "pages/files/contract/content/toBeSigned.content";
import Invoice from "pages/invoice/invoice";
import SettleContent
    from "pages/files/invoices/content/settle.content";
import ToBeSetContent
    from "pages/files/invoices/content/toBeSet.content";
import CreateOfMission from "pages/createOfMission";
import Activity from "pages/activity";
import TimeSheet from "pages/timeSheet/timeSheet";
import CheckedContent
    from "pages/timeSheet/content/checked.content";
import ToBeCheckedContent
    from "pages/timeSheet/content/toBeChecked.content";
import LitigationContent
    from "pages/timeSheet/content/litigation.content";
import PersonalInformation
    from "pages/personalInformation/personalInformation";
import MyAccountPersonalContent
    from "pages/personalInformation/content/myAccountPersonal.content";
import ParamsContent
    from "pages/personalInformation/content/params.content";
import MissionFiche from "pages/missionFiche";
import InvoiceFiche from "pages/invoiceFiche";
import ContractFiche from "pages/contractFiche";
import LayoutCompany from "components/layout";
import PdfView from "pages/pdfView";
import MissionTemplates from "pages/missionTemplates";
import CreateOfTemplate from "pages/missionTemplates/createOfTemplate";
import {
    ACTIVITY_ROLES,
    CONTRACTS_ROLES,
    DASHBOARD_ROLES,
    INVOICES_ROLES,
    MISSION_CREATION_ROLES,
    MISSIONS_ROLES,
    PERIMETERS_ROLES,
    PERSONAL_INFORMATIONS_ROLES,
    PROFILE_ROLES,
    TEAM_ROLES,
    TIMESHEET_ROLES
} from "routes/roles";


const Index = () => {
    return (
        <>
            <Routes>
                <Route path='/' element={<Layout/>}>
                    <Route path='/entreprise' element={<LayoutCompany/>}/>
                    <Route element={<RequireAuth allowedRoles={DASHBOARD_ROLES}/>}>
                        <Route path='dashboard' element={<Dashboard/>}/>
                        <Route element={<RequireAuth allowedRoles={PROFILE_ROLES}/>}>
                            <Route path='profil' element={<Profil/>}>
                                <Route index element={<Navigate to="myAccountCompany" replace />} />
                                <Route path='myAccountCompany'
                                       element={<MyAccountContent/>}/>
                                <Route path='legalInformation' element={
                                    <LegalInformationContent/>}/>
                                <Route path='modesOfPayments' element={
                                    <ModesOfPaymentContent/>}/>
                                <Route path='bonusesAndCompensation'
                                       element={
                                           <BonusesCompensationContent/>}/>
                                <Route path='paymentsTerms'
                                       element={<PaymentsTermsContent/>}/>
                                {/* Same roles as the profil parent, kept explicit so perimeters stay limited to the roles that manage them */}
                                <Route element={<RequireAuth allowedRoles={PERIMETERS_ROLES}/>}>
                                    <Route path='perimeters' element={<PerimetersContent/>}/>
                                </Route>
                                <Route element={<RequireAuth allowedRoles={TEAM_ROLES}/>}>
                                    <Route path='team' element={<TeamContent/>}/>
                                    <Route path='permissions' element={<PermissionsContent/>}/>
                                </Route>
                            </Route>
                        </Route>
                        <Route element={<RequireAuth allowedRoles={MISSIONS_ROLES}/>}>
                            <Route path={'missions'} element={<Mission/>}>
                                <Route index element={<Navigate to="inProgress" replace />} />
                                <Route path={'end'}
                                       element={<EndContent/>}/>
                                <Route path={'inProgress'}
                                       element={<InProgressContent/>}/>
                                <Route path={'comingSoon'}
                                       element={<ComingSoonContent/>}/>
                            </Route>
                            <Route path={'mission/:id'} element={<MissionFiche/>}/>
                        </Route>
                        <Route element={<RequireAuth allowedRoles={CONTRACTS_ROLES}/>}>
                            <Route path={'contract'} element={<Contract/>}>
                                <Route index element={<Navigate to="toBeSigned" replace />} />
                                <Route path={'signed'}
                                       element={<SignedContent/>}/>
                                <Route path={'toBeSigned'} element={
                                    <ToBeSignedContent/>}/>
                            </Route>
                            <Route path={'contract/detail'} element={<ContractFiche/>}/>
                        </Route>
                        <Route element={<RequireAuth allowedRoles={INVOICES_ROLES}/>}>
                            <Route path={'invoice'} element={<Invoice/>}>
                                <Route index element={<Navigate to="toBeSet" replace />} />
                                <Route path={'settle'}
                                       element={<SettleContent/>}/>
                                <Route path={'toBeSet'}
                                       element={<ToBeSetContent/>}/>
                            </Route>
                            <Route path={'invoice/detail'} element={<InvoiceFiche/>}/>
                        </Route>
                        <Route element={<RequireAuth allowedRoles={TIMESHEET_ROLES}/>}>
                            <Route path={'timeSheet'} element={<TimeSheet/>}>
                                <Route index element={<Navigate to="toBeChecked" replace />} />
                                <Route path={'checked'}
                                       element={<CheckedContent/>}/>
                                <Route path={'toBeChecked'}
                                       element={<ToBeCheckedContent/>}/>
                                <Route path={'litigation'}
                                       element={<LitigationContent/>}/>
                            </Route>
                        </Route>
                        <Route element={<RequireAuth allowedRoles={PERSONAL_INFORMATIONS_ROLES}/>}>
                            <Route path={'personalInformations'} element={<PersonalInformation/>}>
                                <Route path={'myPersonalAccount'}
                                       element={
                                           <MyAccountPersonalContent/>}/>
                                <Route path={'params'}
                                       element={<ParamsContent/>}/>
                            </Route>
                        </Route>
                        <Route element={<RequireAuth allowedRoles={MISSION_CREATION_ROLES}/>}>
                            <Route path={'createOfMission'}
                                   element={<CreateOfMission/>}/>
                            <Route path={'missionTemplates'}
                                   element={<MissionTemplates/>}/>
                            <Route path={'missionTemplates/create'}
                                   element={<CreateOfTemplate mode={'create'}/>}/>
                            <Route path={'missionTemplates/edit/:id'}
                                   element={<CreateOfTemplate mode={'edit'}/>}/>
                        </Route>
                        <Route element={<RequireAuth allowedRoles={ACTIVITY_ROLES}/>}>
                            <Route path={'activityCompany'} element={<Activity/>}/>
                        </Route>
                    </Route>
                    <Route path='pdfView' element={<PdfView/>}/>
                    <Route path={'*'} element={<Unauthorized/>}/>
                    <Route path={""} element={<Navigate to="/dashboard"/>}/>
                    <Route path={"*"} element={<Navigate to="/dashboard"/>}/>
                </Route>
            </Routes>
        </>
    );
};

export default Index;
